// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const getCookie = (nome) => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
    const [chave, valor] = cookies[i].split("=");
    if (chave === nome) return valor;
    }
    return null;
}
const token = getCookie("session_token")
export default createConsumer(`wss://${window.location.host}/cable?token=${token}`)
